import request from '@/utils/request'

// 满意度评价列表
export function SatisfactionPageList(data) {
  return request({
    url: '/health-doctor-assistant/satisfactionEvaluation/page-list',
    method: 'post',
    data
  })
}
